import { loadNamespacedLocales } from "./utils/loadNamespacedLocales";

export default defineI18nConfig(() => ({
  legacy: false,
  locale: "en",
  messages: {
    en: loadNamespacedLocales("en"),
    bg: loadNamespacedLocales("bg"),
    mk: loadNamespacedLocales("mk"),
  },
}));
